<script setup lang="ts">
import { ref } from 'vue'
import { useI18n } from 'vue-i18n'
import { useReportInteractionMutation } from '@/composables/queries/cold-monitoring'

const props = defineProps<{
  callId: string
  open: boolean
}>()

const emit = defineEmits<{
  'update:open': [value: boolean]
}>()

const { t } = useI18n({ useScope: 'global' })
const comment = ref<string>('')
const { mutateAsync, isPending } = useReportInteractionMutation()

const close = () => {
  comment.value = ''
  emit('update:open', false)
}

const submit = async (): Promise<boolean> => {
  await mutateAsync({ callId: props.callId, comment: comment.value || null })
  close()
  return true
}
</script>

<template>
  <OModal
    data-testid="report-modal"
    :open="open"
    :title="t('cold_monitoring.report_interaction.title')"
    :primary-action-title="t('cold_monitoring.report_interaction.submit')"
    :secondary-action-title="t('cancel')"
    primary-action-color="success"
    primary-action-enabled
    secondary-action-enabled
    :primary-action-promise="submit"
    :secondary-action-promise="
      () => {
        close()
        return true
      }
    "
    :primary-action-loading="isPending"
    teleport
    @update:open="emit('update:open', $event)"
  >
    <template #content>
      <div class="flex flex-col gap-m">
        <p class="text-neutral-1 typography-body-1">
          {{ t('cold_monitoring.report_interaction.helper_text') }}
        </p>
        <p class="text-neutral-2 typography-body-2">
          {{ t('cold_monitoring.report_interaction.disclaimer') }}
        </p>
        <OTextArea
          v-model="comment"
          data-testid="report-comment"
          :label="t('cold_monitoring.report_interaction.comment.label')"
          :placeholder="t('cold_monitoring.report_interaction.comment.placeholder')"
          :maxlength="2000"
          :rows="4"
        />
      </div>
    </template>
  </OModal>
</template>
